<template>
  <div>
    <heading>{{ $t("sidebar.asaMeetings") }}</heading>
    <div class="d-flex justify-end mb-4">
      <asaMeetingTransfer @transferred="loadCounts" />
      <v-btn v-if="canCreateHere" color="secondary" outlined @click="newMeeting">
        {{ $t("asaMeeting.new") }}
        <v-icon right>add</v-icon>
      </v-btn>
    </div>
    <dateFolderTable
      :rows="rows"
      :loading="loading"
      :nameLabel="$t('folders.year')"
      @open="openYear"
    />
  </div>
</template>

<script>
import dateFolderTable from "../../components/_utils/dateFolderTable.vue";
import asaMeetingTransfer from "./asaMeetingTransfer.vue";

export default {
  name: "asaMeetingYears",
  components: { dateFolderTable, asaMeetingTransfer },
  data: () => ({ counts: {}, loading: false }),
  created() {
    this.loadCounts();
  },
  computed: {
    rows() {
      const present = Object.keys(this.counts)
        .map(Number)
        .filter((n) => !Number.isNaN(n));
      const currentYear = new Date().getFullYear();
      const min = Math.min(currentYear, ...present);
      const max = Math.max(currentYear, ...present);
      const rows = [];
      for (let y = max; y >= min; y--) {
        rows.push({
          key: String(y),
          label: String(y),
          total: (this.counts[String(y)] || {}).total || 0,
        });
      }
      return rows;
    },
  },
  methods: {
    async loadCounts() {
      this.loading = true;
      try {
        this.counts = (await this.$store.dispatch("getAsaMeetingYearCounts")) || {};
      } finally {
        this.loading = false;
      }
    },
    openYear(row) {
      this.$router.push({ name: "asaMeetingList", params: { year: row.key } });
    },
    newMeeting() {
      this.$router.push({ name: "asaMeetingForm", params: { id: "new", mode: "new" } });
    },
  },
};
</script>
